import { __awaiter, __generator } from "tslib";
import { logError } from '@office-start/telemetry-service';
import React from 'react';
import ReactDOM from 'react-dom';
import { HiddenIframeForMOSWarmup } from './HiddenIframeForMOSWarmup';
export var preWarmCopilotApp = function () {
    var fetchUrlAndRenderHiddenIframe = function () { return __awaiter(void 0, void 0, void 0, function () {
        var maxRetries, attempts, baseDelay, _loop_1, state_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    maxRetries = 3;
                    attempts = 0;
                    baseDelay = 300;
                    _loop_1 = function () {
                        var containerElement, url, error_1, delay_1;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    _b.trys.push([0, 1, , 3]);
                                    containerElement = document.createElement('div');
                                    containerElement.setAttribute('id', 'PreWarmMOSApps');
                                    document.body.appendChild(containerElement);
                                    url = 'https://outlook.office.com/semanticoverview/m365ChatSSO';
                                    ReactDOM.render(React.createElement(HiddenIframeForMOSWarmup, {
                                        id: 'prewarmCopilotApp',
                                        src: url,
                                    }), containerElement);
                                    return [2 /*return*/, "break"];
                                case 1:
                                    error_1 = _b.sent();
                                    attempts += 1;
                                    logError({
                                        eventName: 'PreWarmCopilotMosApp',
                                        errorType: 'PreWarmCopilotMosApp_Error',
                                        message: 'Failed to pre-warm MOS apps iframe after attempt ${attempts.toString()}',
                                        area: 'PreWarmMosApp',
                                    });
                                    delay_1 = baseDelay * Math.pow(2, attempts - 1);
                                    return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, delay_1); })];
                                case 2:
                                    _b.sent(); // Delay before retrying
                                    return [3 /*break*/, 3];
                                case 3: return [2 /*return*/];
                            }
                        });
                    };
                    _a.label = 1;
                case 1:
                    if (!(attempts < maxRetries)) return [3 /*break*/, 3];
                    return [5 /*yield**/, _loop_1()];
                case 2:
                    state_1 = _a.sent();
                    if (state_1 === "break")
                        return [3 /*break*/, 3];
                    return [3 /*break*/, 1];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    fetchUrlAndRenderHiddenIframe();
};
//# sourceMappingURL=preWarmCopilotApp.js.map